import { Typography } from '@mui/material';

import { CommunityProductPurchaseList } from 'features/community-products/components';
import { useCurrentUserAvailableCommunityProducts } from 'features/community-products/hooks';
import { UserMembershipsList } from 'features/memberships/components';
import { useCurrentUserProductMemberships } from 'features/memberships/hooks';
import { useCurrentUser } from 'shared/hooks';

import { Container, Content, Header, Section } from './SettingsMemberships.styles';

/**
 * Displays the current user's memberships.
 */
export function SettingsMemberships() {
  const {
    data: memberships,
    isLoading: isMembershipsLoading,
    isIdle: isMembershipsIdle,
  } = useCurrentUserProductMemberships();

  const { user, loading: isUserLoading } = useCurrentUser();

  const { data: availableProducts, isLoading: isProductsListLoading } =
    useCurrentUserAvailableCommunityProducts();

  const isLoading = isMembershipsLoading || isMembershipsIdle || isUserLoading;

  return (
    <Container>
      <Header>
        <Typography variant="h6">My Memberships</Typography>
      </Header>

      <Content>
        <Section>
          <Typography>Manage your memberships to access exclusive content or features.</Typography>

          <UserMembershipsList user={user} memberships={memberships} isLoading={isLoading} />
        </Section>

        <Section>
          <Typography>Purchase memberships to access exclusive content or features.</Typography>

          <CommunityProductPurchaseList
            products={availableProducts}
            isLoading={isProductsListLoading}
          />
        </Section>
      </Content>
    </Container>
  );
}
